/*
 *
 * MobileNavBar
 *
 * @version 1.0.0
 * @author Davide Polci
 * @since 21-Oct-2024
 */

import MobileNavBar from './MobileNavBarContainer'

export default MobileNavBar
